//import {Header} from './components/componenteheader/header'
import Header from './components/componenteheader/header';
import {Footer} from './components/componentefooter/footer'

import {Home} from './Views/home/home'
import {Profile} from './Views/profile/profile'
import {Experience} from './Views/experience/experience'
import Projects from './Views/projects/projects'
import {Contact} from './Views/contact/contact'
import {NotFound} from './Views/notfound/notfound'

import {BenchPowerSupply} from './Views/projects/projectscontent/benchpowersupplyproject/benchpowersupply.js'
import {CncRouter} from './Views/projects/projectscontent/cncrouterproject/cncrouter.js'
import {Drone} from './Views/projects/projectscontent/droneproject/drone.js'
import {GoKart} from './Views/projects/projectscontent/gokartproject/gokart.js'
import {Processor} from './Views/projects/projectscontent/processorproject/processor.js'
import {SmartRoom} from './Views/projects/projectscontent/smartroom/smartroom.js'

import 'katex/dist/katex.min.css';

import { useEffect } from 'react';
import {Route,Routes,useLocation} from 'react-router-dom'

const PAGE_TITLES = {
  '/': 'Igor Tomich — Computer Engineer | Portfolio',
  '/home': 'Home — Igor Tomich',
  '/profile': 'About — Igor Tomich',
  '/experience': 'Experience — Igor Tomich',
  '/contact': 'Contact — Igor Tomich',
  '/projects': 'Projects — Igor Tomich',
  '/projects/bench-power-supply': 'Bench Power Supply — Igor Tomich',
  '/projects/cnc-router': 'CNC Router — Igor Tomich',
  '/projects/drone': 'Drone — Igor Tomich',
  '/projects/go-kart': 'Go-Kart — Igor Tomich',
  '/projects/processor': 'Processor — Igor Tomich',
  '/projects/smart-room': 'Smart Room — Igor Tomich',
};

function App() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace(/\/+$/, '') || '/';
    document.title = PAGE_TITLES[path] || 'Page Not Found — Igor Tomich';

    // Per-route canonical so SPA sub-pages aren't all canonicalized to "/".
    const canonicalUrl = 'https://scridernewage.netlify.app' + (path === '/' ? '/' : path);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
  }, [location]);

  return (
        
    <>
    <Header/>
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/profile' element={<Profile/>}/>
      <Route path='/experience' element={<Experience/>}/>
      <Route path='/home' element={<Home/>}/>
      <Route path='/contact' element={<Contact/>}/>
      <Route path='/projects' element={<Projects/>}>
        <Route path='/projects/processor' element={<Processor/>}/>
        <Route path='/projects/bench-power-supply' element={<BenchPowerSupply/>}/>
        <Route path='/projects/cnc-router' element={<CncRouter/>}/>
        <Route path='/projects/drone' element={<Drone/>}/>
        <Route path='/projects/go-kart' element={<GoKart/>}/>
        <Route path='/projects/smart-room' element={<SmartRoom/>}/>
      </Route>
      <Route path='/*' element={<NotFound/>} /> 
    </Routes>
    <Footer/>
    </>

  );
}

export default App;



